import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listDrive = ({siteId, folderId, snapshotDateTime, pagination, searchTerm, siteIds}) => {
  return POST('recovery/sites/drive/search', {siteId, folderId, snapshotDateTime, pagination, searchTerm: trimString(searchTerm), siteIds})
}

const listBreadcrumps = ({siteId, folderId, snapshotDate}) => {
  return POST('recovery/sites/drive/breadcrumbs', {siteId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, extension, code, storageDestinationId, dataType, storageDestinationType}) => {
  return POST('recovery/sites/drive/export', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), selectedIds, extension, storageDestinationId, dataType, storageDestinationType}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, RestoreType, code}) => {
  return POST('recovery/sites/drive/restore', {snapshotDateTime, sourceIds, searchTerm: trimString(searchTerm), destinationId, snapshotId, selectedIds, RestoreType}, {code: code ? code : null})
}

export {
  listDrive,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
